import { render, staticRenderFns } from "./eyeBiologyTest.vue?vue&type=template&id=639b0c83&scoped=true&"
import script from "./eyeBiologyTest.vue?vue&type=script&lang=js&"
export * from "./eyeBiologyTest.vue?vue&type=script&lang=js&"
import style0 from "./eyeBiologyTest.vue?vue&type=style&index=0&id=639b0c83&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b0c83",
  null
  
)

export default component.exports